import { render, staticRenderFns } from "./ProductCompareForm.vue?vue&type=template&id=20fe49d8&scoped=true&"
import script from "./ProductCompareForm.vue?vue&type=script&lang=js&"
export * from "./ProductCompareForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductCompareForm.vue?vue&type=style&index=0&id=20fe49d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe49d8",
  null
  
)

export default component.exports